import { render, staticRenderFns } from "./planDetail.vue?vue&type=template&id=79c7132b&scoped=true&"
import script from "./planDetail.vue?vue&type=script&lang=js&"
export * from "./planDetail.vue?vue&type=script&lang=js&"
import style0 from "./planDetail.vue?vue&type=style&index=0&id=79c7132b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c7132b",
  null
  
)

export default component.exports